import { BrowserModule } from '@angular/platform-browser';
import { APP_BASE_HREF } from '@angular/common';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxMoveableModule } from "ngx-moveable";
import { DatePipe } from '@angular/common'
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatSortModule } from '@angular/material/sort';
import { FacebookModule } from 'ngx-facebook';
import { NgSlimScrollModule, SLIMSCROLL_DEFAULTS, ISlimScrollOptions } from 'ngx-slimscroll';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { NgxPaginationModule } from 'ngx-pagination';
import { AgmCoreModule } from '@agm/core';
import { RouterModule, Routes, Router, ActivatedRoute, Params } from '@angular/router';

/*  Ref Internes  */

import { DownloadAppComponent } from 'projects/hp-api/src/lib/download-app/download-app.component';
import { ClickOutsideDirective } from 'projects/hp-api/src/lib/app-entry/click-outside.directive';
import { OrderByPipe } from 'projects/hp-api/src/lib/pipes/filter-by-id.pipe';
import { DevisFormComponent } from 'projects/hp-api/src/lib/devis-form/devis-form.component';
import { StreetViewMapComponent } from 'projects/hp-api/src/lib/street-view-map/street-view-map.component';
import { LoginComponent } from 'projects/hp-api/src/lib/login/login.component';
import { AlertComponent } from 'projects/hp-api/src/lib/alert/alert.component';
import { SignConfirmComponent } from 'projects/hp-api/src/lib/dialogs/sign-confirm/sign-confirm.component';
import { UserInformationComponent } from 'projects/hp-api/src/lib/dialogs/user-information/user-information.component';
import { PdfDialogComponent } from 'projects/hp-api/src/lib/dialogs/pdf-dialog/pdf-dialog.component';
import { ArchivesComponent } from 'projects/hp-api/src/lib/archives/archives.component';
import { GooglePlacesComponent } from 'projects/hp-api/src/lib/google-places/google-places.component';
import { InfosPrixComponent } from 'projects/hp-api/src/lib/dialogs/infos-prix/infos-prix';
import { MaisonsComponent } from 'projects/hp-api/src/lib/maisons/maisons.component';
import { vueMaisonComponent } from 'projects/hp-api/src/lib/dialogs/vue-maison/vue-maison.component';
import { FinaliserComponent } from 'projects/hp-api/src/lib/finaliser/finaliser.component';
import { FinaliserIframeComponent } from '../finalser-iframe/finaliser-iframe.component'; 
import { SocialMediasComponent } from 'projects/hp-api/src/lib/dialogs/social-medias/social-medias.component';
import { ModalInfoComponent } from 'projects/hp-api/src/lib/base/modal-info.component';
import { SimulationAideComponent } from 'projects/hp-api/src/lib/simulation-aide/simulation-aide.component';
import { InfosComponent } from 'projects/hp-api/src/lib/dialogs/infos/infos.component';
import { HomeComponent } from 'projects/hp-api/src/lib/home/home.component';
import { AuthGuardGuard } from 'projects/hp-api/src/lib/helpers/auth-guard.guard';
import { AuthentificationService } from 'projects/hp-api/src/lib/services/authentification-service.service';
import { FamillesChildComponent } from 'projects/hp-api/src/lib/familles-child/familles-child.component';
import { SelecteurPorteComponent } from 'projects/hp-api/src/lib/selecteur-porte/selecteur-porte.component';
import { ProduitsComponent } from 'projects/hp-api/src/lib/produits/produits.component';
import { SimulateurComponent } from 'projects/hp-api/src/lib/simulateur/simulateur.component';
import { FamillesComponent } from 'projects/hp-api/src/lib/familles/familles.component';
import { FormesComponent } from '../formes/formes.component'; 
import { MenuSystemComponent } from 'projects/hp-api/src/lib/simulateur/menu-system/menu-system.component';
import { MobileMenuComponent } from 'projects/hp-api/src/lib/simulateur/mobile/menu/mobile-menu.component';
import { WizardQuestionsMenuComponent } from 'projects/hp-api/src/lib/simulateur/wizard-menu/wizard-questions-menu.component';
import { WizardAnswersMenuComponent } from 'projects/hp-api/src/lib/simulateur/wizard-menu/wizard-answers-menu.component';
import { WizardImageControllerComponent } from 'projects/hp-api/src/lib/simulateur/wizard-product-image/wizard-image-controller.component';
import { WizardExpansionMenuComponent } from '../simulateur/wizard-menu/wizard-expansion-menu.component';
import { WizardMultiMenuComponent } from '../simulateur/wizard-menu/wizard-multi-menu.component';
import { WizardVariableComponent } from '../simulateur/wizard-menu/wizard-variable.component';
import { NavbarComponent } from 'projects/hp-api/src/lib/navbar/navbar.component';
import { WizardHpModelFilterSelecteurPorteComponent } from '../selecteur-porte/wizard-hp-model-filter-selecteur-porte-component';
import { WizardHpModelFilterTextSelecteurPorteComponent } from '../selecteur-porte/wizard-hp-model-filter-text-selecteur-porte-component';

import { WizardHpModelFilterSimulateurComponent } from '../simulateur/wizard-menu/wizard-hp-model-filter-simulateur-component';
import { WizardHpModelFilterTextSimulateurComponent } from '../simulateur/wizard-menu/wizard-hp-model-filter-text-simulateur-component';

import { DelayedInputDirective } from 'projects/hp-api/src/lib/base/delayed-input.directive';


import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  MatCardModule,
  MatCheckboxModule,
  MatMenuModule,
  MatTabsModule,
  MatDialogModule,
  MatButtonModule,
  MatToolbarModule,
  MatIconModule,
  MatBadgeModule,
  MatSidenavModule,
  MatListModule,
  MatGridListModule,
  MatSelectModule,
  MatRadioModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatChipsModule,
  MatTooltipModule,
  MatTableModule,
  MatPaginatorModule,
  MatProgressSpinnerModule,
  MatAutocompleteModule,
  MatExpansionModule,
  MatSlideToggleModule,
  MatBottomSheetModule,
  MatSliderModule,
  MAT_FORM_FIELD_DEFAULT_OPTIONS
} from '@angular/material';
import { SafePipe } from '../pipes/pipe-transform';
import { WizardAnswersMultiMenuComponent } from '../simulateur/wizard-menu/wizard-answers-multi-menu.component';
import { WizardNavCatalogComponent } from '../simulateur/wizard-menu/wizard-nav-catalog.component';
import { CataloguesComponent } from '../catalogues/catalogues.component';
import { MaisonSimuleoStandardComponent } from '../maisons/maisons-simuleo-standard.component';
import { MaisonMobileComponent } from '../dialogs/vue-maison/maisons-mobile.component';
import { WizardInfosProduitComponent } from '../simulateur/wizard-menu/wizard-infos-produit.component';
import { WizardWindowsMenuComponent } from '../simulateur/wizard-menu/wizard-windows-menu.component';
import { WizardMultiExpansionMenuComponent } from '../simulateur/wizard-menu/wizard-multi-expansion-menu.component';
import { WizardNavCloneDeleteComponent } from '../simulateur/wizard-menu/wizard-nav-clone-delete.component';
import { WizardStepMultiMenuComponent } from '../simulateur/wizard-menu/wizard-step-multi-menu.component';
import { WizardReglageComponent } from '../simulateur/menu-system/wizard-reglage.component';

export function initConfig(hpService: HpService) {
  return () => hpService.loadConfig();
}

@NgModule({
  declarations: [
    ClickOutsideDirective,
    OrderByPipe,
    DevisFormComponent,
    StreetViewMapComponent,
    LoginComponent,
    AlertComponent,
    SignConfirmComponent,
    UserInformationComponent,
    DownloadAppComponent,
    PdfDialogComponent,
    ArchivesComponent,
    GooglePlacesComponent,
    InfosPrixComponent,
    MaisonsComponent,
    MaisonSimuleoStandardComponent,
    SelecteurPorteComponent,
    vueMaisonComponent,
    MaisonMobileComponent,
    FinaliserComponent,
    FinaliserIframeComponent,
    SocialMediasComponent,
    ModalInfoComponent,
    SimulationAideComponent,
    InfosComponent,
    HomeComponent,
    FamillesChildComponent,
    ProduitsComponent,
    FamillesComponent,
    FormesComponent,
    CataloguesComponent,
    SafePipe, 
    //HP

    MenuSystemComponent,
    MobileMenuComponent,
    WizardQuestionsMenuComponent,
    WizardVariableComponent,
    WizardAnswersMenuComponent,
    WizardInfosProduitComponent,
    WizardNavCatalogComponent,
    WizardAnswersMultiMenuComponent,
    WizardImageControllerComponent,
    WizardExpansionMenuComponent,
    WizardMultiExpansionMenuComponent,
    WizardMultiMenuComponent,
    WizardWindowsMenuComponent,
    WizardStepMultiMenuComponent,
    WizardHpModelFilterSelecteurPorteComponent,
    WizardHpModelFilterTextSelecteurPorteComponent,
    WizardHpModelFilterSimulateurComponent,
    WizardHpModelFilterTextSimulateurComponent,
    WizardNavCloneDeleteComponent,
    WizardReglageComponent,
    DelayedInputDirective,
    NavbarComponent,
    SimulateurComponent
  ],

  imports: [

    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgxMoveableModule,
    ReactiveFormsModule,
    NgSlimScrollModule,
    GooglePlaceModule,
    ScrollingModule,
    FormsModule,
    DragDropModule,
    MatCheckboxModule,
    MatSortModule,
    MatMenuModule,
    MatTabsModule,
    MatDialogModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatBadgeModule,
    MatSidenavModule,
    MatListModule,
    MatGridListModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatChipsModule,
    MatTooltipModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    MatCardModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatAutocompleteModule,
    NgxPaginationModule,
    MatSliderModule,
    MatFormFieldModule,
    MatInputModule,
    FacebookModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: "getQuestionObjectAIzaSyDrAJDuuXmw1uDWqD18Pq5j7T6wj6tkm4o",
      libraries: ["places", "geometry"]
      /* apiKey is required, unless you are a premium customer, in which case you can use clientId */
    }),

  ],
  exports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgxMoveableModule,
    ReactiveFormsModule,
    NgSlimScrollModule,
    GooglePlaceModule,
    ScrollingModule,
    FormsModule,
    DragDropModule,
    MatCheckboxModule,
    MatSortModule,
    MatMenuModule,
    MatTabsModule,
    MatDialogModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatBadgeModule,
    MatSidenavModule,
    MatListModule,
    MatGridListModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatChipsModule,
    MatTooltipModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    MatCardModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatAutocompleteModule,
    MatSliderModule,
    MatFormFieldModule,
    MatInputModule,
    NgxPaginationModule,
    ClickOutsideDirective,
    OrderByPipe,
    DevisFormComponent,
    StreetViewMapComponent,
    LoginComponent,
    AlertComponent,
    SignConfirmComponent,
    UserInformationComponent,
    DownloadAppComponent,
    PdfDialogComponent,
    ArchivesComponent,
    GooglePlacesComponent,
    InfosPrixComponent,
    MaisonsComponent,
    MaisonSimuleoStandardComponent,
    SelecteurPorteComponent,
    vueMaisonComponent,
    MaisonMobileComponent,
    FinaliserComponent,
    FinaliserIframeComponent,
    SocialMediasComponent,
    ModalInfoComponent,
    SimulationAideComponent,
    InfosComponent,
    HomeComponent,
    FamillesChildComponent,
    ProduitsComponent,
    FamillesComponent,
    FormesComponent,
    CataloguesComponent,

    //HP

    MenuSystemComponent,
    MobileMenuComponent,
    WizardQuestionsMenuComponent,
    WizardVariableComponent,
    WizardAnswersMenuComponent,
    WizardNavCatalogComponent,
    WizardAnswersMultiMenuComponent,
    WizardImageControllerComponent,
    WizardExpansionMenuComponent,
    WizardMultiMenuComponent,
    WizardWindowsMenuComponent,
    WizardStepMultiMenuComponent,
    WizardMultiExpansionMenuComponent,
    WizardInfosProduitComponent,
    WizardHpModelFilterSelecteurPorteComponent,
    WizardHpModelFilterTextSelecteurPorteComponent,
    WizardHpModelFilterSimulateurComponent,
    WizardHpModelFilterTextSimulateurComponent,
    WizardHpModelFilterSimulateurComponent,
    WizardNavCloneDeleteComponent,
    WizardReglageComponent,
    DelayedInputDirective,
    NavbarComponent,
    SimulateurComponent
  ],
  providers: [
    HpService,
    AuthentificationService,
    AuthGuardGuard,
    DatePipe, 
    {
      provide: APP_INITIALIZER, useFactory: initConfig, deps: [HpService],
      multi: true
    },
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'outline'}},
    { provide: LocationStrategy, useClass: HashLocationStrategy }
    , OrderByPipe, DeviceDetectorService
  ],
  entryComponents: [DevisFormComponent, SimulationAideComponent, ModalInfoComponent, SignConfirmComponent, StreetViewMapComponent, UserInformationComponent, InfosComponent, 
        PdfDialogComponent, InfosPrixComponent, LoginComponent, AlertComponent, vueMaisonComponent,MaisonMobileComponent, SocialMediasComponent]
})
export class AppBaseModule { }

